module.exports = __webpack_public_path__ + "img/helen-full.c8dd6e94.png";